import React from 'react';
import { compose } from 'redux';
import { withLayout } from 'components/Components/Layouts/ThemeContext/with-layout';
import { withRouteParams } from 'hoc/withRouteParams';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    buildDestinationBySlugSelector,
} from 'store/selectors/destinations.selector';
import { buildHotelBySlugSelector } from 'store/selectors/hotels.selector';
import DestinationPage from '../DestinationPage';
import HotelPage from '../HotelPage';
import { isEmpty } from 'lodash';

const SharedRoutePage = ({ destination, hotel, params, themeContext }) =>
{
    if (!isEmpty(hotel))
    {
        return (<HotelPage params={{ ...params, hotelSlug: params.slug }} themeContext={themeContext} />);
    }

    if (!isEmpty(destination))
    {
        return (<DestinationPage params={params} themeContext={themeContext} />);
    }

    return null;
};

SharedRoutePage.propTypes = {
    destination: PropTypes.object,
    hotel: PropTypes.object,
    params: PropTypes.object.isRequired,
    themeContext: PropTypes.object,
};

const mapStateToProps = () =>
{
    const destinationSelector = buildDestinationBySlugSelector(false);
    const hotelSelector = buildHotelBySlugSelector();

    return (state, props) => ({
        destination: destinationSelector(state, props.params.slug),
        hotel: hotelSelector(state, props.params.slug),
    });
};

const mapDispatchToProps = () => () => ({});


export default compose(
    withLayout,
    withRouteParams,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(withLayout(SharedRoutePage));
